import { useIntercom } from '@/hooks/useIntercom'

/**
 * Zero-UI component that mounts the useIntercom hook inside the router context.
 * Place inside AppShell so it has access to useLocation().
 */
export default function IntercomManager() {
  useIntercom()
  return null
}
